import BaseService from './base-service.js'

const baseUrlProducts = '/products/bo'

export default {
    async findProduct({ id }) {
        const { data } = await BaseService.get(
            `${baseUrlProducts}/product/${id}`
        )
        return data
    },

    async getCategories() {
        const { data } = await BaseService.get(`${baseUrlProducts}/categories`)
        return data
    },

    async getProducts() {
        const { data } = await BaseService.get(`${baseUrlProducts}/products`)
        return data
    },
}
